/*
 * @Description:
 * @Author: muqingkun
 * @Date: 2023-10-09 15:26:31
 * @LastEditTime: 2024-05-08 18:28:25
 * @LastEditors: Please set LastEditors
 * @Reference:
 */
// import "@/utils/sso";
// import { getConfig } from '@/config';
import NProgress from '@/utils/progress';
import { getToken } from '@/utils/auth';
import { usePermissionStoreHook } from '@/store/modules/permission';
import { useUserStoreHook } from '@/store/modules/user';
import { useBaseStoreHook } from '@/store/modules/base';
import {
  Router,
  createRouter,
  RouteRecordRaw,
  RouteComponent
} from 'vue-router';
import {
  ascending,
  handleAsyncRoutes,
  getHistoryMode,
  handleAliveRoute,
  formatTwoStageRoutes,
  formatFlatteningRoutes
} from './utils';
import { getInfo } from '@/api/user';
// import {  } from '@/router/utils';
import { buildHierarchyTree } from '@/utils/tree';
import { isUrl, openLink } from '@pureadmin/utils';
// import { isUrl, openLink, storageSession } from '@pureadmin/utils';

import remainingRouter from './modules/remaining';
import versionCheck from '@/utils/versionCheck';
/** 路由白名单 */
const whiteList = ['/login'];
import { $t } from '@/plugins/i18n';
// import { constantsRouter } from '@/router/constants';
import { ElMessage } from 'element-plus';

/** 自动导入全部静态路由，无需再手动引入！匹配 src/router/modules 目录（任何嵌套级别）中具有 .ts 扩展名的所有文件，除了 remaining.ts 文件
 * 如何匹配所有文件请看：https://github.com/mrmlnc/fast-glob#basic-syntax
 * 如何排除文件请看：https://cn.vitejs.dev/guide/features.html#negative-patterns
 */
const modules: Record<string, any> = import.meta.glob(
  ['./modules/**/*.ts', '!./modules/**/remaining.ts'],
  {
    eager: true
  }
);
/** 原始静态路由（未做任何处理） */
const routes: any[] = [];
// routes.push(home);

Object.keys(modules).forEach(key => {
  if (Array.isArray(modules[key].default)) {
    routes.push(...modules[key].default);
  } else {
    routes.push(modules[key].default);
  }
});

/** 导出处理后的静态路由（三级及以上的路由全部拍成二级） */
export const constantRoutes: Array<RouteRecordRaw> = formatTwoStageRoutes(
  formatFlatteningRoutes(buildHierarchyTree(ascending(routes)))
);

/** 用于渲染菜单，保持原始层级 */
export const constantMenus: Array<RouteComponent> = ascending(remainingRouter);

/** 不参与菜单的路由 */
export const remainingPaths = Object.keys(remainingRouter).map((v: any) => {
  return remainingRouter[v].path;
});

/** 创建路由实例 */
export const router: Router = createRouter({
  history: getHistoryMode(import.meta.env.VITE_ROUTER_HISTORY),
  routes: constantRoutes.concat(...(remainingRouter as any)),
  strict: true,
  scrollBehavior(to, from, savedPosition) {
    return new Promise(resolve => {
      if (savedPosition) {
        return savedPosition;
      } else {
        if (from.meta.saveSrollTop) {
          const top: number =
            document.documentElement.scrollTop || document.body.scrollTop;
          resolve({ left: 0, top });
        }
      }
    });
  }
});

/** 重置路由 */
export function resetRouter() {
  router.getRoutes().forEach(route => {
    const { name, meta } = route;
    if (name && router.hasRoute(name) && meta?.backstage) {
      router.removeRoute(name);
      router.options.routes = formatTwoStageRoutes(
        formatFlatteningRoutes(buildHierarchyTree(ascending(routes)))
      );
    }
  });
  usePermissionStoreHook().clearAllCachePage();
}

// // 重定义路由path赋值
// export function filterRouterPath(routeList: Array<any>) {
//   return routeList.map(item => {
//     if (item.routePath) {
//       item.path = item.routePath.includes('/')
//         ? item.routePath
//         : '/' + item.routePath;
//     }

//     if (item.children && item.children.length > 0) {
//       item.children = filterRouterPath(item.children);
//     }
//     return item;
//   });
// }

// 重定义路由path赋值
export function filterRouterPath(routeList: Array<any>) {
  return routeList.map(item => {
    if (item.routePath) {
      item.path = item.routePath.includes('/')
        ? item.routePath
        : '/' + item.routePath;
    }
    if (item.children && item.children.length > 0) {
      item.children = filterRouterPath(item.children);
    }
    return item;
  });
}

export const handleMenuData = (data: Array<any>, parentPath = '') => {
  return data.map(item => {
    item.name = item.name.replace('/', '');
    item.meta = {
      icon: item.icon,
      title: item.name,
      keepAlive: true
    };
    if (item.menuType === 3 && !item.path) {
      item.path = parentPath;
    }
    if (item.children && item.children.length > 0) {
      item.children = handleMenuData(item.children, item.path);
    }
    return item;
  });
};

router.beforeEach(async (to, _from, next) => {
  await versionCheck();
  if (to.meta?.keepAlive) {
    const newMatched = to.matched;
    handleAliveRoute(newMatched, 'add');
    // 页面整体刷新和点击标签页刷新
    if (_from.name === undefined || _from.name === 'Redirect') {
      handleAliveRoute(newMatched);
    }
  }
  NProgress.start();
  const externalLink = isUrl(to?.name as string);
  // if (!externalLink) {
  //   to.matched.some(item => {
  //     if (!item.meta.title) return '';
  //     const Title = getConfig().Title;
  //     if (Title) document.title = `${$t(item.meta.title)} | ${$t(Title)}`;
  //     else document.title = item.meta.title as string;
  //   });
  // }

  /** 如果已经登录并存在登录信息后不能跳转到路由白名单，而是继续保持在当前页面 */
  async function toCorrectRoute() {
    whiteList.includes(to.fullPath) ? next(_from.fullPath) : next();
  }

  if (getToken()) {
    if (_from?.name) {
      // name为超链接
      if (externalLink) {
        openLink(to?.name as string);
        NProgress.done();
      } else {
        toCorrectRoute();
      }
    } else {
      // 刷新
      if (
        usePermissionStoreHook().wholeMenus.length === 0 &&
        to.path !== '/login'
      ) {
        const { data } = await getInfo();
        if (!data.permissionMenus || !data.permissionMenus.length) {
          // 无权限 自动退出
          usePermissionStoreHook().clearAllCachePage();
          useUserStoreHook().logOut();
          ElMessage($t('该用户无权限, 禁止登陆系统'), {
            type: 'error',
            duration: 5 * 1000
          });
          window.location.reload();
        }
        useUserStoreHook().SET_ROLETYPE(data.loginUserRoleType);
        const menu = filterRouterPath(data.permissionMenus);
        const newMenu = handleMenuData(menu);
        // console.log('newMenu: ', newMenu);
        handleAsyncRoutes(newMenu).then(() => {
          useBaseStoreHook().setDictList({});
          router.push(to.fullPath);
        });
      }
      toCorrectRoute();
    }
  } else {
    if (to.path !== '/login') {
      if (whiteList.indexOf(to.path) !== -1) {
        next();
      } else {
        next({ path: '/login' });
      }
    } else {
      next();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
